import ICON_EVENT from "../img/icon_events.svg"
import ICON_NEWS from "../img/icon_news.svg"
import ICON_FEEDBACK from "../img/icon_feedback.svg"
import ICON_EDIT from "../img/icon_edit.svg"
import ICON_X from "../img/cuestick_hamburger_open.png"
import ICON_IG from "../img/ig_logo.svg"
import ICON_DELETE from "../img/icon_delete.svg"
import ICON_LINKTREE from "../img/icon_linktree.svg"

const DEFAULT_ICON_WIDTH = 20

/**
 * 
 * Type like, event, news (booleans)
 */
const Icon = ({ onClick, width, height, className, event, news, feedback, edit, X, IG, del, linktree }) => {

    const getSrc = () => {
        if (event) {
            return ICON_EVENT
        } else if (news) {
            return ICON_NEWS
        } else if (feedback) {
            return ICON_FEEDBACK
        } else if (edit) {
            return ICON_EDIT
        } else if (X) {
            return ICON_X
        } else if (IG) {
            return ICON_IG
        } else if (del) {
            return ICON_DELETE
        } else if (linktree) {
            return ICON_LINKTREE
        }
    }

    return (
        <img
            src={getSrc()}
            className={className}
            width={width ? width : (height ? height: DEFAULT_ICON_WIDTH)}
            height={height ? height : (width ? width: DEFAULT_ICON_WIDTH)}
            alt=""
            onClick={onClick}
        />
    )
}

export default Icon